import { Component, OnInit } from '@angular/core';
import { UsuariosService } from '../../infrastructure/services/usuarios.service';
import { ActivatedRoute, Params } from '@angular/router';
import { saveAs } from 'file-saver';
import { File64 } from '../../helpers/components/sxFileImport/file64.interf';
import { AlertService } from '../../infrastructure/services/alert.service';

@Component({
    selector: 'massive-import',
    templateUrl: './massive-import.component.html'
})
export class MassiveImportComponent implements OnInit {
    codSistema = null;
    codNegocio = null;
    supported: string[] = ['.xls'];
    file64: File64 = null;
    file: any = null;
    filename: string = null;

    constructor(private usuariosService: UsuariosService, private aRoute: ActivatedRoute, private alertService: AlertService) {

    }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.codSistema = params['codsistema'] === undefined ? null : params['codsistema'];
            this.codNegocio = params['codnegocio'] === undefined ? null : params['codnegocio'];
        });
    }

    downloadTemplate() {
        this.usuariosService.downloadTemplate(this.codSistema, this.codNegocio)
            .then(response => this.downloadExcelFile(response));
    }



    downloadExcelFile(data) {

        // base64 To ArrayBuffer
        const binaryString = atob(data.fileContents);
        const binaryLen = binaryString.length;
        const bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
            const ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        // -------

        this.download(bytes, data.fileDownloadName, data.contentType);
    }


    download(content, filename, contentType) {
        const blob = new Blob([content], { 'type': contentType });
        saveAs(blob, filename);
    }


    uploadFile() {
        this.usuariosService.invocarComando(this.codSistema, this.codNegocio, 'AltaMasiva', [], [], this.file)
            .then(response => {
                this.file = null;
                this.filename = null;
                this.alertService.showSuccessMessage('Users succesfully created');
            });
    }

    theFileChosen(imp: File64) {
        this.file64 = imp;
        this.filename = this.file64.fileName;
        this.file = imp.fileData;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/usuarios/massive-import.component.ts